"use strict";

/* =========================================
   NINJA STRAP LP - Shopify統合最終版
========================================= */

document.addEventListener("DOMContentLoaded", () => {

  /* ==================================================
     ANIMATION
  ================================================== */

  const FADE_THRESHOLD = 0.2;
  const FADE_MARGIN = "0px 0px -8% 0px";
  const CARD_DELAY = 120;
  const CARD_TEXT_OFFSET = 80;

  const fadeTargets = document.querySelectorAll(
    ".js-animate, .js-image-fade"
  );

  if (fadeTargets.length) {

    const fadeObserver = new IntersectionObserver((entries, obs) => {

      entries.forEach(entry => {

        if (!entry.isIntersecting) return;

        if (entry.target.classList.contains("js-image-fade")) {
          setTimeout(() => {
            entry.target.classList.add("is-show");
          }, 120);
        } else {
          entry.target.classList.add("is-show");
        }

        obs.unobserve(entry.target);
      });

    }, {
      threshold: FADE_THRESHOLD,
      rootMargin: FADE_MARGIN
    });

    fadeTargets.forEach(target => fadeObserver.observe(target));
  }

  /* USAGEカード順番表示 */
  const usageSection = document.querySelector("#usage");

  if (usageSection) {

    const usageObserver = new IntersectionObserver((entries, obs) => {

      entries.forEach(entry => {

        if (!entry.isIntersecting) return;

        const cards = usageSection.querySelectorAll(".usage-card");

        cards.forEach((card, index) => {

          const image = card.querySelector(".usage-card__image");
          const body  = card.querySelector(".usage-card__body");

          if (image) {
            setTimeout(() => {
              image.classList.add("is-show");
            }, index * CARD_DELAY);
          }

          if (body) {
            setTimeout(() => {
              body.classList.add("is-show");
            }, index * CARD_DELAY + CARD_TEXT_OFFSET);
          }

        });

        obs.unobserve(entry.target);
      });

    }, { threshold: 0.3 });

    usageObserver.observe(usageSection);
  }

/* ==================================================
   HERO CATCH
================================================== */
function initHeroCatch() {

  if (typeof gsap === "undefined") return;
  if (typeof ScrollTrigger === "undefined") return;

  const section = document.querySelector(".catch-hero");
  if (!section) return;

  const dim = section.querySelector(".catch-hero__dim");
  const lead = section.querySelector(".catch-hero__lead");

  if (!dim || !lead) return;

  gsap.registerPlugin(ScrollTrigger);

  /* ==============================
     ① 背景暗転（スクロール連動）
  ============================== */
  gsap.to(dim, {
    opacity: 0.5,
    ease: "none",
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
      end: "top 30%",
      scrub: true
    }
  });

  /* ==============================
     ② キャッチコピー（ふわっと単発）
  ============================== */
  gsap.fromTo(
    lead,
    { y: 20, opacity: 0 },
    {
      y: 0,
      opacity: 1,
      duration: 0.7,
      ease: "power2.out",
      scrollTrigger: {
        trigger: lead,
        start: "top 90%",
        toggleActions: "play none none none"
      }
    }
  );
}

  /* ==================================================
     SWIPER
  ================================================== */

  function initSwiper() {

    if (typeof Swiper === "undefined") return;

    const MAX_WIDTH = 1280;

    /* USAGE */
    const usageSlider = document.querySelector(".js-usage-slider");

    if (
      usageSlider &&
      !usageSlider.classList.contains("swiper-initialized")
    ) {
      new Swiper(".js-usage-slider", {
        slidesPerView: "auto",
        centeredSlides: true,
        centeredSlidesBounds: true,
        speed: 700,
        mousewheel: { forceToAxis: true },
        navigation: {
          nextEl: ".js-usage-next",
          prevEl: ".js-usage-prev",
        },
        breakpoints: {
          0: { spaceBetween: 15 },
          1068: { spaceBetween: 31 }
        }
      });
    }

    /* SELECT */
    const selectSlider = document.querySelector(".js-select-slider");
    const selectTabs = document.querySelectorAll(".select-tabs__btn");

    if (
      selectSlider &&
      selectTabs.length > 0 &&
      !selectSlider.classList.contains("swiper-initialized")
    ) {

      function calculateOffset() {
        return Math.max((window.innerWidth - MAX_WIDTH) / 2, 0);
      }

      const selectSwiper = new Swiper(".js-select-slider", {
        slidesPerView: "auto",
        centeredSlides: true,
        centeredSlidesBounds: false,
        slidesOffsetBefore: calculateOffset(),
        slidesOffsetAfter: calculateOffset(),
        speed: 750,
        watchOverflow: true,
        mousewheel: { forceToAxis: true },
        breakpoints: {
          0: { spaceBetween: 10 },
          1068: { spaceBetween: 20 }
        }
      });

      window.addEventListener("resize", () => {
        const offset = calculateOffset();
        selectSwiper.params.slidesOffsetBefore = offset;
        selectSwiper.params.slidesOffsetAfter = offset;
        selectSwiper.update();
      });

      selectSwiper.on("activeIndexChange", () => {

        selectTabs.forEach(tab => {
          tab.classList.remove("is-active");
          tab.setAttribute("aria-selected", "false");
        });

        const activeTab = selectTabs[selectSwiper.activeIndex];

        if (activeTab) {
          activeTab.classList.add("is-active");
          activeTab.setAttribute("aria-selected", "true");
        }
      });

      selectTabs.forEach(tab => {
        tab.addEventListener("click", () => {
          const index = Number(tab.dataset.index);
          if (!isNaN(index)) {
            selectSwiper.slideTo(index, 550);
          }
        });
      });
    }
  }

  /* ==================================================
     ACCORDION
  ================================================== */

  function initAccordion() {

    const section = document.querySelector('.product-problem');
    const triggers = document.querySelectorAll(".js-accordion");
    const items = document.querySelectorAll(".accordion__item");
    const pcImages = document.querySelectorAll(".product-problem__image img");
    const pcWrapper = document.querySelector(".product-problem__image");

    if (!section || !triggers.length) return;

    const isSP = () => window.matchMedia("(max-width: 767px)").matches;

    function closeAll() {

      items.forEach((item) => {

        item.classList.remove("is-open");

        const body = item.querySelector(".accordion__body");
        if (body) body.style.height = "0px";

        const spImg = item.querySelector(".accordion__image-sp img");
        const spWrapper = item.querySelector(".accordion__image-sp");

        if (spImg) {
          spImg.style.opacity = "0";
          spImg.style.transform = "translateY(8px)";
        }

        if (spWrapper) {
          spWrapper.classList.remove("has-active");
        }
      });

      pcImages.forEach(img => img.classList.remove("is-active"));

      if (pcWrapper) {
        pcWrapper.classList.remove("has-active", "is-switching");
      }
    }

    function showWithTempo(item, target) {

      const firstDelay  = isSP() ? 120 : 180;
      const secondDelay = isSP() ? 250 : 350;

      setTimeout(() => {

        if (!isSP() && pcWrapper) {
          pcWrapper.classList.add("is-switching");
        }

        setTimeout(() => {

          if (isSP()) {

            const spImg = item.querySelector(".accordion__image-sp img");
            const spWrapper = item.querySelector(".accordion__image-sp");

            if (spImg) {
              spImg.style.opacity = "1";
              spImg.style.transform = "translateY(0)";
            }

            if (spWrapper) {
              spWrapper.classList.add("has-active");
            }

          } else {

            pcImages.forEach((img) => {
              if (img.dataset.image === target) {
                img.classList.add("is-active");
              }
            });

            if (pcWrapper) {
              pcWrapper.classList.add("has-active");
              pcWrapper.classList.remove("is-switching");
            }
          }

        }, secondDelay);

      }, firstDelay);
    }

function openItem(item) {

  const body = item.querySelector(".accordion__body");
  const target = item.dataset.target;

  closeAll();
  item.classList.add("is-open");

  if (body) {

    // 一旦 0 にしてから
    body.style.height = "0px";

    //  120msの溜め
    setTimeout(() => {
      body.style.height = body.scrollHeight + "px";
    }, 120);
  }

  showWithTempo(item, target);
}

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {

        const item = trigger.closest(".accordion__item");
        if (!item || item.classList.contains("is-open")) return;

        if (isSP()) {

          openItem(item);

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {

              const offset = 40;
              const top = item.getBoundingClientRect().top + window.pageYOffset - offset;

              window.scrollTo({
                top: top,
                behavior: "smooth"
              });

            });
          });

        } else {
          openItem(item);
        }
      });
    });

    closeAll();

if (items.length > 0) {

  const observer = new IntersectionObserver((entries, obs) => {

    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      if (isSP()) {
        obs.disconnect();
        return;
      }

      // テキストは開かない
      const firstItem = items[0];
      const target = firstItem.dataset.target;

      setTimeout(() => {

        pcImages.forEach(img => {
          if (img.dataset.image === target) {
            img.classList.add("is-active");
          }
        });

        if (pcWrapper) {
          pcWrapper.classList.add("has-active");
        }

      }, 450);

      obs.disconnect();
    });

  }, { threshold: 0.4 });

  observer.observe(section);
}
  }

  /* ==================================================
     INIT
  ================================================== */

  initHeroCatch();
  initSwiper();
  initAccordion();

});